import React from 'react';
import { usePathname } from 'next/navigation';
import * as S from './SearchPanel.styles';
import { SearchPanelForm } from './components/SearchPanelForm';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import { ROUTES } from '@/constants/routes';

interface SearchPanelProps {
  hideOnDesktop?: boolean;
}

export const SearchPanel = ({ hideOnDesktop }: SearchPanelProps) => {
  const pathname = usePathname();

  return (
    <S.SearchPanelBox
      data-testid={CommonTestIds.searchPanel.box}
      $isHomePage={pathname === ROUTES.home}
      $hideOnDesktop={hideOnDesktop}
    >
      <SearchPanelForm />
    </S.SearchPanelBox>
  );
};
